import React, {useState, useEffect, useRef} from 'react';
import {
  Flex,
  TableContainer,
  Thead,
  Tbody,
  Tr,
  Td,
  Table,
  TableCaption,
  Tfoot,
  IconButton,
  useDisclosure,
  Divider,
  Box,
  Button,
  Spinner,
} from '@chakra-ui/react';
import LoadingWheel from '../../components/General/LoadingWheel';
import {get, postDelete, queryStringBuilder, getFile} from '../../service/ApiService';
import {Batch, SMaster, Survey} from '../../service/Urls';
import {FaTrashAlt, FaEdit, FaSearch} from 'react-icons/fa';
import {useLocation, useNavigate} from 'react-router-dom';
import ModalYesNo from '../../components/General/ModalYesNo';
import {PageButtons, setGrid, setSearchHeaders} from '../../helpers/SetGrid';
import ErrorHelper from '../../service/ErrorHelper';
import BoxCard from '../../components/General/BoxCard';
import {SubmitButton} from '../../components/General/FormInputs';
import {useForm} from 'react-hook-form';
import ServiceTypeList from '../../components/General/ServiceTypeList';
import {ClientSelect} from '../../components/Client/ClientSelect';
import {getServiceType} from '../../helpers/ServiceTypeDictionary';
import {Report} from '../../service/Urls';
// import useEventListener from '../../helpers/useEventListener';

const BatchLookup = () => {
  const [masterData, setMasterData] = useState([]);
  const [toastResponse, setToastResponse] = useState(undefined);
  const [searchHeaders, setHeaders] = useState({});

  const [forDelete, setForDelete] = useState({id: '', masterName: ''});
  const [elements, setElements] = useState({body: {}, header: {}, footer: {}});
  const [isLoading, setLoading] = useState(true);
  const [serviceType, setServiceType] = useState(1);

  const [pdfUrl, setPdfUrl] = useState('');
  const linkRef = useRef(null);

  const [loadingReport, setLoadingReport] = useState(false);

  const location = useLocation();

  const [pages, setPages] = useState({
    pageNum: 1,
    totalPages: 5,
    itemsPerPage: 5,
    getNewPage: curPage => {
      loadData(curPage);
    },
  });

  const isMounted = useRef(false);

  const navigate = useNavigate();
  const {isOpen, onOpen, onClose} = useDisclosure();
  const {
    register,
    handleSubmit,
    watch,
    control,
    formState: {errors},
  } = useForm();

  const watchAllFields = watch();

  const isPrintDisabled = Object.entries(watchAllFields).every(([key, value]) => !value || key === 'ServiceType');

  // useRef will save this across renders so it's not reloaded every time
  // to add more fields to the table, simply add their name and type to this json
  // if a new type is added you'll have to update the table to reflect that type (ie. dropdown or button)
  const visibleData = useRef({
    batchNumber: 'text',
    clientName: 'text',
    importDate: 'date',
    startDate: 'date',
    endDate: 'date',
  });

  // for the individual search inputs - What the id's and types of the formdata should be that is sent to the api when posting
  const searchIds = useRef({
    batchNumber: 'text',
    clientName: 'text',
    ImportDate: 'date',
    startDate: 'date',
    endDate: 'date',
  });

  // Initial load of the page
  useEffect(() => {
    isMounted.current = true;
    loadData(1);

    return () => {
      isMounted.current = false;
    };
  }, []);

  const loadData = async () => {
    const svcType = location?.state?.serviceType?.value ?? 1;
    setServiceType(svcType);
    // initial search values
    const queryParams = {
      Page: 1,
      PageSize: 100,
      ServiceType: svcType,
      OrderBy: 'importDate',
      IsDescendingSort: true,
    };
    queryData(queryParams);
  };

  // Need this to repopulate everything on the UI any time the data from the web changes
  useEffect(() => {
    masterData.map(record => {
      if (record.ImportDate) {
        record.ImportDate = record.ImportDate.replaceAll('-', '/');
        record.ImportDate = record.ImportDate.substring(0, record.ImportDate.indexOf('T'));
      }
    });
    populateData();
  }, [masterData]);

  // if no masterId is passed in, we'll assume we're adding.
  const edit = batchId => {
    navigate('/reports/BatchPrint', {state: {id: batchId}});
  };

  // const setForDeletion = id => {
  //   const record = masterData.filter(record => record.id == id);
  //   setForDelete({id: id, recordNumber: record[0].recordNumber});
  //   onOpen();
  // };

  // const deleteMaster = async () => {
  //   const data = await postDelete(SMaster.DELETE, `"${forDelete.id}"`);
  //   setToastResponse({response: data, successMessage: 'Successfully deleted record ' + forDelete.recordNumber});
  //   if (!data.error) {
  //     loadData();
  //     onClose();
  //   }
  // };
  useEffect(() => {
    setLoading(true);
    loadData(pages.pageNum);
  }, [pages]);

  const populateData = () => {
    // for the function parameters passed in we're going to use the id of data being populated, can do other stuff with it but that was best solution I could come up with
    // this id will be set in the setGrid when the data is populated... really hoping all of our data will have id's!
    const ExtraColumns = ({batch}) => {
      return (
        <>
          <Td>
            <IconButton colorScheme="tertiary" title="Edit" size="sm" icon={<FaEdit />} mr="2" onClick={() => edit(batch)} />
            {/* <IconButton colorScheme="tertiary" title="Delete" size="md" icon={<FaTrashAlt />} onClick={() => setForDeletion(id)} /> */}
          </Td>
        </>
      );
    };
    setGrid(visibleData, masterData, pages, setElements, ExtraColumns);
    // setSearchHeaders(searchIds, setHeaders, register, errors, ascFunc, descFunc);
    setSearchHeaders(searchIds, setHeaders, register, errors);
  };

  const search = async formData => {
    // delete any empty parameters
    // setLoading(true);
    setServiceType(parseInt(formData.ServiceType));
    formData.OrderBy = 'importdate';
    formData.IsDescendingSort = true;
    Object.keys(formData).forEach(k => !formData[k] && formData[k] !== undefined && delete formData[k]);
    await queryData(formData);
  };

  const queryData = async formData => {
    formData.Page = 1;
    formData.PageSize = 100;
    const data = await get(queryStringBuilder(Batch.LIST, formData));
    // console.log('formData ' + JSON.stringify(formData));
    setToastResponse({response: data});
    if (!data.error) {
      if (data.data.length === 1) {
        edit(data.data[0].batchId);
      } else {
        setMasterData(data.data);
        setLoading(false);
      }
    }
  };

  const printReport = async () => {
    const params = {
      StartDate: watchAllFields.startDate || '2001-01-01',
      EndDate: watchAllFields.endDate || new Date().toISOString().substring(0, 10),
      ServiceType: watchAllFields.ServiceType,
      Batch: watchAllFields.batchNumber,
      ClientName: watchAllFields.clientName,
      ImportDate: watchAllFields.ImportDate,
    };
    const url = queryStringBuilder(`${Report.DEFAULT_REPORT}${'SurveyBatchHistory.rdlx'}`, params);
    // const url = queryStringBuilder(SurveyPrints.reportbuttonFile, params);
    setLoadingReport(true);
    const response = await getFile(url);
    if (isMounted.current) {
      setLoadingReport(false);
    }
    if (response.error) {
      setToastResponse({response: {error: 1}, errorMessage: 'Error getting report: ' + response.error});
      return;
    }

    const fileURL = window.URL.createObjectURL(response);
    if (!response.error) {
      setPdfUrl(fileURL);
    }
  };

  // Used both of these functions for sorting but decided to take them out for now - ALV 20220513
  // const ascFunc = orderBy => {
  //   setLoading(true);
  //   handleSubmit(data => {
  //     Object.keys(data).forEach(k => !data[k] && data[k] !== undefined && delete data[k]);
  //     data.OrderBy = orderBy;
  //     data.IsDescendingSort = false;
  //     queryData(data);
  //   })();
  // };

  // const descFunc = orderBy => {
  //   setLoading(true);
  //   handleSubmit(data => {
  //     Object.keys(data).forEach(k => !data[k] && data[k] !== undefined && delete data[k]);
  //     data.OrderBy = orderBy;
  //     data.IsDescendingSort = true;
  //     queryData(data);
  //   })();
  // };

  useEffect(() => {
    if (pdfUrl.length > 0) linkRef.current.click();
  }, [pdfUrl]);

  return (
    <>
      <a href={pdfUrl} target="_blank" rel="noopener noreferrer" ref={linkRef} style={{display: 'none'}} />
      {isLoading ? (
        <>
          <LoadingWheel />
          <ErrorHelper toastResponse={toastResponse} />
        </>
      ) : (
        <form onSubmit={handleSubmit(search)}>
          <BoxCard>
            <Flex gap={5} alignItems="center" mt={3}>
              {/* <ClientSelect register={register} errors={errors} id={'ClientId'} useId /> */}
              {/* <Spacer />
              <ArrangerSelect register={register} errors={errors} id={'arCode'} />
              <Spacer /> */}
              <Box>
                <ServiceTypeList control={control} defaultValue={serviceType} />
              </Box>
              <SubmitButton name="Search" rightIcon={<FaSearch />} colorScheme="tertiary" w="25%" />
              <Button
                name="PrintList"
                variant="outline"
                colorScheme="secondary"
                w="10%"
                disabled={isPrintDisabled || loadingReport}
                onClick={printReport}
              >
                {loadingReport ? <Spinner size="sm" /> : 'Print List'}
              </Button>
            </Flex>

            <Divider my="5" colorScheme={'mint'} />

            <TableContainer>
              <Table variant="striped" colorScheme="mint" size={'sm'}>
                <TableCaption>Batch Lookup</TableCaption>
                <Thead>
                  <Tr>
                    {searchHeaders}
                    <Td px="-2"></Td>
                  </Tr>
                </Thead>
                <Tbody>{elements.body}</Tbody>
                <Tfoot>
                  <Tr>
                    <Td />
                    <Td />
                    <Td />
                    <Td />
                    <Td />
                    <Td>{/* <PageButtons pages={pages} /> */}</Td>
                    <Td />
                    <Td />
                    <Td />
                    <Td />
                  </Tr>
                </Tfoot>
              </Table>
            </TableContainer>
            {/* <ModalYesNo
              isOpen={isOpen}
              onOpen={onOpen}
              onClose={onClose}
              title="Delete record"
              body={'Are you sure you want to delete record ' + forDelete.recordNumber}
              yesFunction={deleteMaster}
            /> */}
          </BoxCard>
          <ErrorHelper toastResponse={toastResponse} />
        </form>
      )}
    </>
  );
};

export default BatchLookup;
